import wx from 'weixin-js-sdk'
import { Toast } from 'vant'
Toast.allowMultiple()

// 获取URL参数指定值
function getUrlCode (code) {
  const search = window.location.search.substr(1)
  const rag = RegExp('(^|&)' + code + '=([^&]*)(&|$)', 'i')
  const result = search.match(rag)
  return result ? result[2] : null
}

function wxSdk (data) {
  return new Promise((resolve, reject) => {
    wx.error(res => {
      reject(res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
    wx.ready(res => {
      resolve(res)
      var shareData = {
        title: data.title || '', // 分享标题
        desc: data.desc || '', // 分享描述
        link: data.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: data.imgUrl || '', // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: e => { // 用户确认分享后执行的回调函数
        },
        cancel: e => { // 用户取消分享后执行的回调函数
        }
      }
      wx.onMenuShareTimeline(shareData)
      wx.onMenuShareAppMessage(shareData)
    })
  })
}

// 获取环境变量
function getObjByPrefix (obj = process.env, prefix = 'VUE_APP_') {
  const envVariables = {}
  Object.entries(obj).filter(e => e[0].startsWith(prefix))
    .sort((e1, e2) => e1[0] - e2[0])
    .map(([k, v]) => {
      Object.assign(envVariables, {
        [k.replace(prefix, '')]: v
      })
    })
  return envVariables
}

const envVariables = getObjByPrefix()

const hosts = getObjByPrefix(envVariables, 'host_')

// object拼接成url字符串
function joinObj (obj) {
  let s = ``
  Object.entries(obj).map(([k, v], i) => {
    let f = ['Array', 'Object'].includes(getDataType(v))
    s += (i ? `&` : ``) + k + `=` + encodeURIComponent(f ? JSON.stringify(v) : v)
  })
  return s
}

// 获取数据类型
export const getDataType = (data) => Object.prototype.toString.call(data).replace('[object ', '').replace(']', '')

// 酷开登录
function onLogin (loginMethod, redirectTo) {
  const { clientIdPassport, hostPassport } = envVariables
  const loginType = (loginMethod || 'account,weixin,qq,phoneDynameic').split(',')
  const loginLength = loginType.length
  const params = {
    client_id: clientIdPassport,
    state: 'loginSuccess',
    approval_prompt: 'force',
    loginMethod: `${encodeURIComponent(loginType.join(','))}`,
    theme: loginLength === 1 ? 'coocaa-pay-login' : 'coocaa-added-service',
    response_type: 'code',
    redirect_uri: redirectTo || `${window.location.href}`
  }
  window.location.href = `${hostPassport}/oauth2/auth?${joinObj(params)}`
}
function log ({ name, data }) {
  const eventNameMap = {
    scrm_web_page_show: '曝光',
    scrm_web_button_clicked: '点击'
  }
  const ruleId = getUrlCode('ruleId')
  const linkCode = getUrlCode('linkCode')
  const userInfo = JSON.parse(localStorage.getItem('userinfo'))
  const nickname = userInfo ? userInfo.nick_name : undefined
  const baseData = {
    active_id: ruleId,
    link_code: linkCode
  }
  if (nickname) {
    baseData.nickname = nickname
  }
  const finalData = {
    ...baseData,
    ...data
  }
  console.log('埋点数据:', name, eventNameMap[name], finalData)
  window._cooc && window._cooc.push(['_trackEvent', name, eventNameMap[name], finalData])
}
export default {
  getUrlCode,
  wxSdk,
  getObjByPrefix,
  envVariables,
  hosts,
  joinObj,
  onLogin,
  log
}
